'use strict';

import $ from 'jquery';

$(function(){

  //----------------------------------------------
  // 全角文字のハイフンを統一
  //----------------------------------------------
  $(document).on( "change", "input.forced-2byte-hypen,textarea.forced-2byte-hypen,.forced-2byte-hypen input,.forced-2byte-hypen textarea", function(){
    $(this).val( $(this).val().replace(/[―−‐\-－]/g, 'ー') );
  });

  //----------------------------------------------
  // 半角の数値を全角数値に変換
  //----------------------------------------------
  $(document).on( "change", "input.forced-2byte-number,textarea.forced-2byte-number,.forced-2byte-number input,.forced-2byte-number textarea", function(){
    $(this).val(
      $(this).val().replace(/[0-9]/g, function(s){
        return String.fromCharCode(s.charCodeAt(0) + 0xFEE0);
      })
    );
  });

});
